export const getTotalDataUsage = {
  variable: '$serviceReq: ServiceReq!',
  query: `getTotalSize(serviceReq: $serviceReq) {
        totalSizeList {
            type,
            metricsSize {
                currentMonth,
                lastMonth,
                secondLastMonth
            },
            traceSize {
                currentMonth,
                lastMonth,
                secondLastMonth
            },
            dBSize {
                currentMonth,
                lastMonth,
                secondLastMonth
            },
            logsSize {
                currentMonth,
                lastMonth,
                secondLastMonth
            },
            currentMonthTotalUsage,
            lastMonthTotalUsage,
            secondLastMonthTotalUsage
        }
    }`,
};

export const getTotalActiveAgents = {
  variable: '$serviceReq: ServiceReq!',
  query: `getActiveAgents(serviceReq: $serviceReq) {
        activeAgentsListPerCapability {
            type,
            totalAgents,
            activeAgents
        }
    }`,
};

export const getLicenseDistributonData = {
  variable: '$teamId: String!',
  query: `getLicenseDistribution( teamId: $teamId) { status data {dataset { capability totalSize } datasetNotInUse overUtilizedDataset totalDatasetCapacityBytes totalDatasetUsedBytes session { capability totalSize } sessionNotInUse overUtilizedSession totalSessionCapacity totalSessionUsed endpoint { capability totalSize }   endpointNotInUse overUtilizedEndpoint totalEndpointCapacity totalEndpointUsed   endDate noOfServices} }`,
};

export const getLicenseUsageData = {
  variable: '$duration: Duration!, $teamId: String!, $type: String!',
  query: `getLicenseUsageConsumption(duration: $duration, teamId: $teamId, type: $type)
     { 
        status 
        data 
            { 
                value
                totalSize 
            }  
    } `,
};

export const getUsedCapacityData = {
  variable: '$duration: Duration!, $teamId: String!',
  query: `getLicenseUsageConsumption(duration: $duration, teamId: $teamId) {
   status
    data {
      total {
        dataset {
          totalSize
          totalUsed
        }
        session {
          totalSize
          totalUsed
        }
        endpoint {
          totalSize
          totalUsed
        }
      }
    }
  }`,
};

export const getLicenseUsageForServices = {
  variable:
    '$duration: Duration!, $teamId: String!, $capability: String!, $serviceIds: [String!]!',
  query: `getLicenseUsageForServices(duration: $duration, teamId: $teamId, capability: $capability, serviceIds: $serviceIds) { status data { serviceId serviceName usage { totalUsagePercent totalUsage values { value totalSize } } } }`,
};

export const getTopLicenseApplication = {
  variable: '$teamId: String!, $type: String!',
  query: `getCapabilityUsageDistribution( teamId: $teamId, type: $type) { status data { values { capability services { serviceId serviceName totalSize } } total { totalSize
 totalUsed } } }`,
};

export const getCapabilityLicenseUsage = {
  variable: '$duration: Duration!, $teamId: String!, $type: String!',
  query: `getLicenseUsage(duration: $duration, teamId: $teamId, type: $type) {
        status data {
            capability 
            values { 
                value 
                totalSize 
            } 
        } 
  }`,
};

export const getLicenseExpiry = {
  variable: '$teamId: String!',
  query: `getLicenseDistribution( teamId: $teamId) { 
    status 
    data {
    dataset {
     capability 
     totalSize
    } 
    datasetNotInUse 
    overUtilizedDataset 
    totalDatasetCapacityBytes 
    totalDatasetUsedBytes 
    session { capability totalSize } 
    sessionNotInUse 
    overUtilizedSession 
    totalSessionCapacity 
    totalSessionUsed 
    endpoint { capability totalSize }   
    endpointNotInUse 
    overUtilizedEndpoint 
    totalEndpointCapacity 
    totalEndpointUsed   
    endDate 
    noOfServices
    status
    } }`,
};
